import { BadgesScreen } from '@/screens/badges-screen/BadgesScreen'

export default function () {
  return <BadgesScreen />
}